export default __webpack_public_path__ + "static/media/Moonpay.c5d105c8.svg";